
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { TaskActionModel } from 'models/generated/Entities.GormCrm.TaskAction';
import { TaskflowModel } from 'models/generated/Entities.GormCrm.Taskflow';
import { OrderOnboardingViewModel } from 'models/generated/Models.OrderOnboardingView';
import { QualificationCallOverviewModel } from 'models/generated/Models.QualificationCallOverview';
import { TaskflowTemplateModel } from 'models/generated/Entities.GormCrm.TaskflowTemplate';
import { TagModel } from 'models/generated/Models.TagModel';
import { TaskAreaModel } from 'models/generated/Entities.GormCrm.TaskArea';
import { TaskAttachmentModel } from 'models/generated/Entities.GormCrm.TaskAttachment';
import { UserQualificationCallViewModel } from 'models/generated/Models.UserQualificationCallView';


const _gormCrm_TaskControllerHelper = new Map<string, Object>();
_gormCrm_TaskControllerHelper.set('GetTaskAction', TaskActionModel);
_gormCrm_TaskControllerHelper.set('GetTaskActions', TaskActionModel);
_gormCrm_TaskControllerHelper.set('GetTaskActionsByTrackingId', TaskActionModel);
_gormCrm_TaskControllerHelper.set('GetUsersOpenTaskActions', TaskActionModel);
_gormCrm_TaskControllerHelper.set('GetUsersOpenSalesflows', TaskActionModel);
_gormCrm_TaskControllerHelper.set('GetTaskActionsFromQuery', TaskActionModel);
_gormCrm_TaskControllerHelper.set('CreateTaskActionWithNewTaskflow', TaskActionModel);
_gormCrm_TaskControllerHelper.set('CloseTaskAction', TaskActionModel);
_gormCrm_TaskControllerHelper.set('RescheduleTaskAction', TaskActionModel);
_gormCrm_TaskControllerHelper.set('UpdateTaskActionAssignedTo', TaskActionModel);
_gormCrm_TaskControllerHelper.set('UpdateTaskActionDetails', TaskActionModel);
_gormCrm_TaskControllerHelper.set('UpdateTaskActionArea', TaskActionModel);
_gormCrm_TaskControllerHelper.set('UpdateTaskActionPlannedDate', TaskActionModel);
_gormCrm_TaskControllerHelper.set('UpdateTaskActionInquiryReply', TaskActionModel);
_gormCrm_TaskControllerHelper.set('GetTaskflow', TaskflowModel);
_gormCrm_TaskControllerHelper.set('GetCompanyTaskflows', TaskflowModel);
_gormCrm_TaskControllerHelper.set('GetOrderOnboardingTaskflows', OrderOnboardingViewModel);
_gormCrm_TaskControllerHelper.set('GetUnassignedQualificationCalls', QualificationCallOverviewModel);
_gormCrm_TaskControllerHelper.set('CreateTaskflow', TaskflowModel);
_gormCrm_TaskControllerHelper.set('CreateTaskflowFromTag', TaskflowModel);
_gormCrm_TaskControllerHelper.set('GetTaskflowsFromQuery', TaskflowModel);
_gormCrm_TaskControllerHelper.set('UpdateTaskflowProduct', TaskflowModel);
_gormCrm_TaskControllerHelper.set('UpdateTaskflowTitle', TaskflowModel);
_gormCrm_TaskControllerHelper.set('UpdateTaskflowDescription', TaskflowModel);
_gormCrm_TaskControllerHelper.set('UpdateTaskflowDeadline', TaskflowModel);
_gormCrm_TaskControllerHelper.set('UpdateTaskflowOwner', TaskflowModel);
_gormCrm_TaskControllerHelper.set('CloneTaskflowAndCloseTaskAction', TaskflowModel);
_gormCrm_TaskControllerHelper.set('GetTemplates', TaskflowTemplateModel);
_gormCrm_TaskControllerHelper.set('GetTemplate', TaskflowTemplateModel);
_gormCrm_TaskControllerHelper.set('GetAllTaskflowTemplateTags', TagModel);
_gormCrm_TaskControllerHelper.set('CreateTaskflowTemplate', TaskflowTemplateModel);
_gormCrm_TaskControllerHelper.set('UpdateTemplate', TaskflowTemplateModel);
_gormCrm_TaskControllerHelper.set('GetAllTaskTemplateTags', TagModel);
_gormCrm_TaskControllerHelper.set('GetTaskAreas', TaskAreaModel);
_gormCrm_TaskControllerHelper.set('SaveTaskArea', TaskAreaModel);
_gormCrm_TaskControllerHelper.set('GetTaskAttachment', TaskAttachmentModel);
_gormCrm_TaskControllerHelper.set('GetCompanyTaskAttachments', TaskAttachmentModel);
_gormCrm_TaskControllerHelper.set('GetAllUsersWithQualificationCallData', UserQualificationCallViewModel);


export const gormCrm_TaskControllerHelper = _gormCrm_TaskControllerHelper;

